import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  getAnalyticsConsent,
  initialiseAnalytics,
  isAnalyticsConfigured,
  setAnalyticsConsent,
  trackPageView,
} from '../../services/analytics';

export function AnalyticsConsent() {
  const location = useLocation();
  const [consent, setConsent] = useState(getAnalyticsConsent);
  const configured = isAnalyticsConfigured();

  useEffect(() => {
    if (consent === 'granted') initialiseAnalytics();
  }, [consent]);

  if (!configured || consent !== 'unset') return null;

  const choose = (choice: 'granted' | 'denied') => {
    setAnalyticsConsent(choice);
    setConsent(choice);
    if (choice === 'granted') {
      initialiseAnalytics();
      trackPageView(`${location.pathname}${location.search}`);
    }
  };

  return (
    <aside
      aria-label="Analytics choice"
      className="z-20 flex flex-col gap-2 border-b border-slate-300 bg-white px-4 py-2 shadow-sm sm:flex-row sm:items-center sm:justify-between sm:gap-4 sm:py-3"
    >
      <p className="text-xs leading-5 text-slate-600 sm:text-sm">
        <span className="font-semibold text-slate-950">Optional usage analytics.</span>{' '}
        <span className="hidden sm:inline">
          ModelMap can send page and feature events to its self-hosted, cookie-free analytics. Search text and catalog data are not sent.
        </span>
        <span className="sm:hidden">Self-hosted and cookie-free; searches are not sent.</span>{' '}
        <Link to="/privacy" className="font-semibold text-blue-700 underline-offset-2 hover:underline">
          Privacy details
        </Link>
      </p>
      <div className="flex shrink-0 gap-2">
        <button
          type="button"
          onClick={() => choose('granted')}
          className="console-button-primary min-h-9 px-3 py-1 text-xs sm:min-h-11 sm:px-4 sm:py-2 sm:text-sm"
        >
          Allow analytics
        </button>
        <button
          type="button"
          onClick={() => choose('denied')}
          className="console-button-secondary min-h-9 px-3 py-1 text-xs sm:min-h-11 sm:px-4 sm:py-2 sm:text-sm"
        >
          Decline
        </button>
      </div>
    </aside>
  );
}
